import React from 'react'

import { Grid } from '../structure/Grid'

const ToRight = ({ children, ...props }) => (
  <Grid align="center" justify="flex-end" {...props}>
    {children}
  </Grid>
)

export default ToRight
